// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.businessCard {
  position: relative;
}
.businessCard .cardWrap {
  margin: 12px;
  padding: 32px;
  width: 374px;
  height: 272px;
  background: #ffffff;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);
  border-radius: 14px;
  display: inline-block;
}
.businessCard .cardWrap .header {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 34px;
  text-align: center;
  color: #292d31;
}
.businessCard .cardWrap .detailContainer {
  width: 100%;
  margin: auto;
  text-align: center;
  margin-top: 24px;
}
.businessCard .cardWrap .detailContainer .leftDiv {
  width: 139px;
  display: inline-block;
}
.businessCard .cardWrap .detailContainer .centerDivider {
  width: 24px;
  display: inline-block;
}
.businessCard .cardWrap .detailContainer .rightDiv {
  width: 139px;
  display: inline-block;
}
.businessCard .cardWrap .detailContainer .detailHeader {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #c1c1c1;
}
.businessCard .cardWrap .detailContainer .detailContent {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 28px;
  line-height: 38px;
  text-align: center;
  color: #333333;
}
.businessCard .cardWrap button.enterStoreBtn {
  margin-top: 30px;
  width: 310px;
  height: 56px;
  background: #075453;
  border-radius: 8px;
  border: none;
  color: white;
}
.businessCard .cardWrap button.enterStoreBtn:hover {
  background: #043332;
}

.businessCardPlaceholder {
  width: 374px;
  height: 272px;
  background: #eff0f0;
  border: 2px dashed #c1c1c1;
  border-radius: 14px;
  margin: 12px;
  cursor: pointer;
}
.businessCardPlaceholder .imageContainer {
  margin: auto;
  width: 21px;
  margin-top: 100px;
}
.businessCardPlaceholder .textLabel {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  color: #c1c1c1;
  margin-top: 8px;
}`, "",{"version":3,"sources":["webpack://./src/screens/businessEstablishmentChoice/businessCard/businessCard.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;AACI;EACI,YAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,4CAAA;EACA,mBAAA;EACA,qBAAA;AACR;AACQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AACZ;AAEQ;EACI,WAAA;EAEA,YAAA;EACA,kBAAA;EACA,gBAAA;AADZ;AAGY;EACI,YAAA;EACA,qBAAA;AADhB;AAIY;EACI,WAAA;EACA,qBAAA;AAFhB;AAKY;EACI,YAAA;EAEA,qBAAA;AAJhB;AAOY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AALhB;AAOY;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AALhB;AAQQ;EACI,gBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;AANZ;AAQQ;EACI,mBAAA;AANZ;;AAYA;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;AATJ;AAWI;EACI,YAAA;EACA,WAAA;EACA,iBAAA;AATR;AAYI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAVR","sourcesContent":[".businessCard {\n    position: relative;\n\n    .cardWrap {\n        margin: 12px;\n        padding: 32px;\n        width: 374px;\n        height: 272px;\n        background: #ffffff;\n        box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);\n        border-radius: 14px;\n        display: inline-block;\n\n        .header {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 500;\n            font-size: 24px;\n            line-height: 34px;\n            text-align: center;\n            color: #292d31;\n        }\n\n        .detailContainer {\n            width: 100%;\n            // background-color: rebeccapurple;\n            margin: auto;\n            text-align: center;\n            margin-top: 24px;\n\n            .leftDiv {\n                width: 139px;\n                display: inline-block;\n                // background-color: aqua;\n            }\n            .centerDivider {\n                width: 24px;\n                display: inline-block;\n                // background-color: blue;\n            }\n            .rightDiv {\n                width: 139px;\n                // background-color: red;\n                display: inline-block;\n            }\n\n            .detailHeader {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 500;\n                font-size: 14px;\n                line-height: 20px;\n                text-align: center;\n                color: #c1c1c1;\n            }\n            .detailContent {\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 400;\n                font-size: 28px;\n                line-height: 38px;\n                text-align: center;\n                color: #333333;\n            }\n        }\n        button.enterStoreBtn {\n            margin-top: 30px;\n            width: 310px;\n            height: 56px;\n            background: #075453;\n            border-radius: 8px;\n            border: none;\n            color: white;\n        }\n        button.enterStoreBtn:hover {\n            background: #043332;\n        }\n    }\n\n}\n\n.businessCardPlaceholder {\n    width: 374px;\n    height: 272px;\n    background: #eff0f0;\n    border: 2px dashed #c1c1c1;\n    border-radius: 14px;\n    margin: 12px;\n    cursor: pointer;\n\n    .imageContainer {\n        margin: auto;\n        width: 21px;\n        margin-top: 100px;\n    }\n\n    .textLabel {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 18px;\n        line-height: 24px;\n        text-align: center;\n        color: #c1c1c1;\n        margin-top: 8px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
